import { Component, EventEmitter, Input, OnInit, Output } from '@angular/core';
import { FormBuilder, FormGroup, ReactiveFormsModule } from '@angular/forms';
import { AlertService, IAlertType, JobsStoreService } from '../../../../_shared/services';
import { NgIf } from '@angular/common';
import { JobsList, WebserviceResponse } from "../../../../_shared/interfaces";
import { ClrCommonFormsModule, ClrIconModule } from "@clr/angular";
import { ClarityIcons, exclamationCircleIcon, floppyIcon } from "@cds/core/icon";

import moment from "moment";

@Component({
  selector: 'app-job-edit-position',
  standalone: true,
  imports: [
    ReactiveFormsModule,
    ClrCommonFormsModule,
    NgIf,
    ClrIconModule
  ],
  templateUrl: './job-edit-position.component.html',
  styleUrl: './job-edit-position.component.sass'
})
export class JobEditPositionComponent implements OnInit {
  public editJobsForm: FormGroup = new FormGroup({});
  positions: JobsList[] = [];
  loading = false;

  @Input() projectNumber: string = '';
  @Input() jobNumber: number = 0;
  @Input() editPosition: number = 0;
  @Input() editPart: number = 0;
  @Output() updatedPosition = new EventEmitter();

  constructor(
    private jobss: JobsStoreService,
    private fb: FormBuilder,
    private alertDispatcher: AlertService,
  ) {
    ClarityIcons.addIcons(floppyIcon, exclamationCircleIcon);
  }

  ngOnInit(): void {
    this.loadJobsPosition(this.projectNumber, this.jobNumber, this.editPosition, this.editPart);
  }

  initForm() {
    if (!this.positions.length) return;
    if (Object.keys(this.editJobsForm.controls).length > 0) return;

    this.editJobsForm = this.fb.group({
      project_id: [this.projectNumber],
      job_id: [this.jobNumber],
      position: [this.editPosition],
      part: [this.editPart],
      name: [this.positions[0].name],
      technical_drawing: [this.positions[0].technical_drawing],
      material: [this.positions[0].material],
      weight: [this.positions[0].weight],
      description: [this.positions[0].description],
      remarks:  [this.positions[0].remarks],
      side_agreements: [this.positions[0].side_agreements],
      selling_price:  [this.positions[0].selling_price],
      delivery_date:  [this.positions[0].delivery_date ? moment(this.positions[0].delivery_date).format("DD.MM.yyyy") : ''],
      status:  [this.positions[0].status],
      number_of_pieces: [this.positions[0].number_of_pieces],
      budget: [this.positions[0].budget],
      controlling_nr: [this.positions[0].controlling_nr],
      heat_nr: [this.positions[0].heat_nr],
      purchasing_price: [this.positions[0].purchasing_price],
      serial_nr: [this.positions[0].serial_nr],
      specification: [this.positions[0].specification],
      comment_phm: [this.positions[0].comment_phm],
    });
  }

  loadJobsPosition(prid: string, jobid: number, posid: number, partid: number) {
    const posID = posid.toString();
    const partID = partid.toString();
    this.jobss.getJobsPositions(prid, jobid, posID, partID, '0').subscribe({
      next: data => {
        if (!data || data.hasErrors || !data.message) {
          this.alertDispatcher.show({
            message: ' Job-Position konnte nicht geladen werden.',
            clrAlertType: IAlertType.WARNING
          }, 5000);
          return;
        }
        this.positions = data.object;
        this.initForm();
      },
      complete: () => {},
      error: () => {
        return
      }
    });
  }

  updateJobPosition() {
    this.jobss.updateJobPosition(this.editJobsForm.value).subscribe({
      next: (data: WebserviceResponse<JobsList>) => {
        if (!data || data.hasErrors || !data.message) {
          this.alertDispatcher.show({
          message: ' Job-Position konnte nicht geändert werden.',
            clrAlertType: IAlertType.WARNING
        }, 5000);
        return;
        }
        this.updatedPosition.emit(true);

      },
      error: () => {
        return
      }
    });
  }
}
